module.exports = __webpack_public_path__ + "static/img/SearchNews.23f71996.png";